import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vacancy-catalog" }
const _hoisted_2 = {
  key: 0,
  class: "vacancy-catalog__loading"
}
const _hoisted_3 = { class: "vacancy-catalog__wrapper" }
const _hoisted_4 = { class: "ds-panel ds-panel--space_sm" }
const _hoisted_5 = { class: "ds-panel__element ds-panel__element--offset_bottom" }
const _hoisted_6 = { class: "ds-caption ds-caption--size_3md ds-caption--size_4md-sm ds-caption--size_lg-md ds-caption--size_xl-lg ds-caption--size_3xl-xl ds-caption--weight_semi-bold ds-caption--color_dark ds-caption--ff_bahnschrift vacancy-catalog__title" }
const _hoisted_7 = {
  key: 0,
  class: "vacancy-catalog__banner"
}
const _hoisted_8 = { class: "vacancy-catalog__banner-img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "vacancy-catalog__wrapper" }
const _hoisted_12 = { class: "ds-panel ds-panel--space_xl" }
const _hoisted_13 = { class: "ds-panel__element ds-panel__element--offset_bottom" }
const _hoisted_14 = { class: "ds-caption ds-caption--size_2xl ds-caption--size_3xl-lg ds-caption--weight_semi-bold ds-caption--ff_bahnschrift vacancy-catalog__title" }
const _hoisted_15 = {
  key: 0,
  class: "vacancy-catalog__grid"
}
const _hoisted_16 = {
  key: 1,
  class: "vacancy-catalog__empty"
}
const _hoisted_17 = { class: "ds-caption ds-caption--size_sm ds-caption--color_relief-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vacancy_card = _resolveComponent("vacancy-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "i-preloader is-active" }, [
            _createElementVNode("div", { class: "i-preloader__item" })
          ], -1)
        ]))]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('Вакансії')), 1)
              ])
            ]),
            ($setup.bannerSrc)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("picture", _hoisted_8, [
                    _createElementVNode("img", {
                      src: $setup.bannerSrc,
                      alt: "",
                      loading: "lazy"
                    }, null, 8, _hoisted_9)
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.settings?.companyDescription)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "vacancy-catalog__description t-content",
                  innerHTML: $setup.settings.companyDescription
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t('Хто нам потрібен?')), 1)
              ])
            ]),
            ($setup.vacancyList?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vacancyList, (item) => {
                    return (_openBlock(), _createBlock(_component_vacancy_card, {
                      key: item.id,
                      item: item
                    }, null, 8, ["item"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('Наразі немає відкритих вакансій')), 1)
                ]))
          ])
        ], 64))
  ]))
}